import { render, staticRenderFns } from "./AoikumoIntegrationTag.vue?vue&type=template&id=4d6fcf15&"
import script from "./AoikumoIntegrationTag.vue?vue&type=script&lang=js&"
export * from "./AoikumoIntegrationTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d6fcf15')) {
      api.createRecord('4d6fcf15', component.options)
    } else {
      api.reload('4d6fcf15', component.options)
    }
    module.hot.accept("./AoikumoIntegrationTag.vue?vue&type=template&id=4d6fcf15&", function () {
      api.rerender('4d6fcf15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/dahreply/AoikumoIntegrationTag.vue"
export default component.exports